import * as z from 'zod'

import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {PrimerComponentCardSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentCard'
import {PrimerComponentCtaBannerSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentCtaBanner'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'

export const TemplateConfirmationSchema = buildEntrySchemaFor('templateConfirmation', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      ctaBanner: safeOptional(PrimerComponentCtaBannerSchema),
      relatedResources: safeOptional(z.array(PrimerComponentCardSchema)),
    }),
  ),
})

export type ConfirmationPage = z.infer<typeof TemplateConfirmationSchema>
